export {
  US_STATES,
  COUNTRIES,
  EXPENSE_CATEGORIES,
  FILING_STATUSES,
  YES_NO,
  USER_TYPES,
  W2_BOX12_CODES,
} from "@smartwiz/shared-types";

export const COLORS = {
  topLevel: "#ACD3F0",
  subLevel: "#EEF9FF",
  subSubLevel: "#FFFFFF",
  error: "#ed4141",
};

export const MAX_ITEMS_PER_PAGE = 25; // Reduced from 40 for better performance

export const PDF_COLORS = {
  primary: "#2c3e50",
  secondary: "#7f8c8d",
  accent: "#3498db",
  text: "#2c3e50",
};

export const PDF_FONTS = {
  title: 16,
  section: 14,
  subsection: 12,
  body: 10,
};

export const PDF_MARGINS = {
  left: 15,
  top: 40,
  right: 15,
};

export const RESIZE_CONFIG = {
  MIN_PANEL_WIDTH: 30,
  MAX_PANEL_WIDTH: 70,
  DEFAULT_PANEL_WIDTH: 60,
} as const;

export const INVALID_DIAGNOSTIC_ERRORS = ["[Redacted or missing]"];

// Document category types
export type DocumentCategory =
  "identification" | "income" | "credits" | "deductions" | "business" | "other";

// Document category display configuration
// Icons use @tabler/icons-react (Mantine's icon library)
export const DOCUMENT_CATEGORY_CONFIG: Record<
  DocumentCategory,
  { label: string; icon: string; color: string; description: string }
> = {
  identification: {
    label: "Identification",
    icon: "IconId",
    color: "#3B82F6",
    description:
      "ID cards, driver's licenses, and personal identification documents",
  },
  income: {
    label: "Income",
    icon: "IconCurrencyDollar",
    color: "#10B981",
    description: "W-2s, 1099s, and other income documentation",
  },
  credits: {
    label: "Credits",
    icon: "IconDiscount",
    color: "#8B5CF6",
    description: "Forms related to tax credits (childcare, education, etc.)",
  },
  deductions: {
    label: "Deductions",
    icon: "IconReceiptTax",
    color: "#F59E0B",
    description:
      "Mortgage interest, student loan interest, and other deductions",
  },
  business: {
    label: "Business",
    icon: "IconBriefcase",
    color: "#EF4444",
    description: "Business documents and expense reports",
  },
  other: {
    label: "Other",
    icon: "IconFile",
    color: "#6B7280",
    description: "Other documents and miscellaneous files",
  },
};
